import axios from 'axios'
import router from "@/router";
import { getToken, removeToken, LoginInfo, $local, $session } from '@/utils/auth';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
Vue.use(ElementUI);

// 创建可一个新的axios对象
const request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,   // 后端的接口地址  ip:port
    timeout: 30000                          // 30s请求超时
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json';        // 设置请求头格式
    let user = JSON.parse(localStorage.getItem("xm-user") || '{}')  // 获取缓存的用户信息
    // config.headers['token'] = user.token  // 设置请求头
    if ($local.get('user')) {
        config.headers['X-Token'] = getToken()
    }
    return config
}, error => {
    console.error('request error: ' + error) // for debug
    // alert("请求错误")
    Vue.prototype.$message.error("请求错误!")
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;

        // Blob 响应（导出 Excel / 下载文件）：直接返回原始 Blob，不做 JSON 解析
        if (res instanceof Blob) {
            return res;
        }

        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            try {
                res = res ? JSON.parse(res) : res
            } catch (e) {
                // 解析失败保持原样
            }
        }
        if (res && res.code === '401') {
            router.push('/login')
        }
        return res;
    },
    error => {
        console.error('response error: ' + error) // for debug
        // 9-10：后端把原因写在 body 的 msg 里（比如 已存在同名酒店：XXX，请换个名称或直接编辑已有酒店）。
        // 有原因就别再盖一句通用报错，原样交给调用方，各页面的 else 分支会把它显示出来
        let body = error && error.response ? error.response.data : null
        if (typeof body === 'string') { try { body = JSON.parse(body) } catch (e) { /* 保持原样 */ } }
        if (body && typeof body === 'object' && body.msg) {
            if (body.status == null) body.status = (error.response && error.response.status) || 500
            return Promise.resolve(body)
        }
        Vue.prototype.$message.error('服务器错误，请联系管理员! ');
        return Promise.reject(error)
    }
)


export default request